export let roleList = [
  {
    roleId: 1,
    roleName: "管理员"
  },
  {
    roleId: 2,
    roleName: "销售"
  },
  {
    roleId: 3,
    roleName: "客户"
  },
  {
    roleId: 4,
    roleName: "线上人员"
  },
  {
    roleId: 5,
    roleName: "文案编辑员"
  },
  {
    roleId: 6,
    roleName: "案例编辑员"
  },
]
export let permissionMap = {
  // 统计信息权限
  'statistics': {
    view: 'STATISTICS_VIEW',
    edit: 'STATISTICS_EDIT'
  },
  // 需求记录权限
  'demand': {
    view: 'DEMAND_RECORD_VIEW',
    edit: 'DEMAND_RECORD_EDIT'
  },
  // 内容管理权限
  'content': {
    view: 'CONTENT_MANAGEMENT_VIEW',
    edit: 'CONTENT_MANAGEMENT_EDIT'
  },
  // 案例管理权限
  'instance': {
    view: 'INSTANCE_MANAGEMENT_VIEW',
    edit: 'INSTANCE_MANAGEMENT_EDIT'
  },
  // 线上服务权限
  'online': {
    view: 'ONLINE_SERVER_VIEW',
    edit: 'ONLINE_SERVER_EDIT'
  },
  // 信息管理权限
  'information': {
    view: 'INFORMATION_MANAGEMENT_VIEW',
    edit: 'INFORMATION_MANAGEMENT_EDIT'
  },
   // 用户管理权限
  'user': {
    view: 'USER_MANAGEMENT_VIEW',
    edit: 'USER_MANAGEMENT_EDIT'
  },
  // 个人资料权限
  'personal': {
    view: 'PERSONAL_INFORMATION_VIEW',
    edit: 'PERSONAL_INFORMATION_EDIT'
  },
}




// WEBPACK FOOTER //
// ./src/assets/js/constant.js